ixModuleRouting("impactx.rfx", {
    "/rfqclist": {
        template: "<ixa-rfqc-list></ixa-rfqc-list>",
        templateUrl: "modules/rfx/templates/rfqclist.html",
        process: "RFQCView",
        controller: "RFQCListCtrl",
        controllerAs: "rfqcListCtrl",
        workspace: "content",
    },
    "/rfqchistorylist/:baseNo": {
        template:"<ixa-rfqc-history-list></ixa-rfqc-history-list>",
        templateUrl: "modules/rfx/templates/rfqchistorylist.html",
        process: "RFQCView",
        controller: "RFQCHistoryListCtrl",
        controllerAs: "rfqcHistoryListCtrl",
        workspace: "content",
    },
    "/rfqcedit/:id/:copy?": {
        template: "<ixa-rfqc-edit></ixa-rfqc-edit>",
        templateUrl: "modules/rfx/templates/rfqcedit.html",
        process: "RFQCView",
        controller: "RFQCEditCtrl",
        controllerAs: "rfqcEditCtrl",
        workspace: "content",
    },
    "/rfxlistoffer": {
        template: "<ixa-rfx-offers-list></ixa-rfx-offers-list>",
        templateUrl: "modules/rfx/templates/rfxlistoffer.html",
        process: "RFXView",
        controller: "RFXListOfferCtrl",
        controllerAs: "rfxListOfferCtrl",
        workspace: "shop",
    },

    "/rfxbuyerlist": {
        template: "<ixa-rfx-buyer-list></ixa-rfx-buyer-list>",
        templateUrl: "modules/rfx/templates/rfxbuyerlist.html",
        process: "RFXView",
        controller: "RFXBuyerListCtrl",
        controllerAs: "rfxBuyerListCtrl",
        workspace: "shop",
    },

    "/rfxbuyer/:rfqhId/:rfqcId?/:supplierId?/:tenderId?/:lotId?/:productIdToAdd?/:amountToAdd?": {
        templateUrl: "modules/rfx/templates/rfxbuyer.html",
        process: "RFXView",
        controller: "RFXBuyerCtrl",
        controllerAs: "rfxBuyerCtrl",
        workspace: "shop",
    },

    "/rfxpurchaserlist": {
        template: "<ixa-rfx-purchaser-list></ixa-rfx-purchaser-list>",
        templateUrl: "modules/rfx/templates/rfxpurchaserlist.html",
        process: "RFXPurchaserView",
        controller: "RFXPurchaserListCtrl",
        controllerAs: "rfxPurchaserListCtrl",
        workspace: "shop",
    },

    "/rfxthread/buyer/:id": {
        template: "<ixa-rfx-thread-buyer-list></ixa-rfx-thread-buyer-list>",
        templateUrl: "modules/rfx/templates/rfx-thread-list.html",
        process: "RFXThreadBuyerList",
        controller: "RFXThreadListBuyerCtrl",
        controllerAs: "rfxThreadListCtrl",
        workspace: "shop",
    },

    "/rfxthread/support/:id": {
        template: "<ixa-rfx-thread-support-list></ixa-rfx-thread-support-list>",
        templateUrl: "modules/rfx/templates/rfx-thread-list.html",
        process: "RFXThreadSupportList",
        controller: "RFXThreadListSupportCtrl",
        controllerAs: "rfxThreadListCtrl",
        workspace: "shop",
    },

    "/rfxthread/supplier/:id/:supplierId": {
        template: "<ixa-rfx-thread-supplier-list></ixa-rfx-thread-supplier-list>",
        templateUrl: "modules/rfx/templates/rfx-thread-supplier-list.html",
        process: "RFXThreadSupplierList",
        controller: "RFXThreadListSupplierCtrl",
        controllerAs: "rfxThreadListCtrl",
        workspace: "shop",
    },

    "/rfxthread/edit/buyer/:id/:rfqhId/:isSupport?": {
        template: "<ixa-rfx-thread-view-buyer></ixa-rfx-thread-view-buyer>",
        templateUrl: "modules/rfx/templates/rfx-thread-edit-dialog.html",
        process: "RFXThreadBuyerList",
        controller: "RFXThreadViewBuyerCtrl",
        controllerAs: "rfxThreadViewBuyerCtrl",
        workspace: "shop",
    },

    "/rfxthread/edit/support/:id/:rfqhId": {
        template: "<ixa-rfx-thread-view-support></ixa-rfx-thread-view-support>",
        templateUrl: "modules/rfx/templates/rfx-thread-edit-dialog.html",
        process: "RFXThreadSupportList",
        controller: "RFXThreadViewSupportCtrl",
        controllerAs: "rfxThreadViewSupportCtrl",
        workspace: "shop",
    },

    "/rfxthread/edit/supplier/:id/:rfqhId/:supplierId/:isSupport?": {
        template: "<ixa-rfx-thread-view-supplier></ixa-rfx-thread-view-supplier>",
        templateUrl: "modules/rfx/templates/rfx-thread-edit-dialog.html",
        process: "RFXThreadSupplierList",
        controller: "RFXThreadViewSupplierCtrl",
        controllerAs: "rfxThreadViewSupplierCtrl",
        workspace: "shop",
    },

    "/rfxsupportlistrunning": {
        template: "<ixa-rfx-support-list-running></ixa-rfx-support-list-running>",
        templateUrl: "modules/rfx/templates/rfxsupportlistrunning.html",
        process: "RFXSupportView",
        controller: "RFXSupportListRunningCtrl",
        controllerAs: "rfxSupportListRunningCtrl",
        workspace: "shop",
    },
    "/rfxsupportlistclosed": {
        template: "<ixa-rfx-support-list-closed></ixa-rfx-support-list-closed>",
        templateUrl: "modules/rfx/templates/rfxsupportlistclosed.html",
        process: "RFXSupportView",
        controller: "RFXSupportListClosedCtrl",
        controllerAs: "rfxSupportListClosedCtrl",
        workspace: "shop",
    },
    "/rfxsupport/:rfqhId": {
        template: "<ixa-rfx-support></ixa-rfx-support>",
        templateUrl: "modules/rfx/templates/rfxsupport.html",
        process: "RFXSupportView",
        controller: "RFXSupportCtrl",
        controllerAs: "rfxSupportCtrl",
        workspace: "shop",
    },
    "/rfqcinfo/:id": {
        template:"<ixa-rfqc-info></ixa-rfqc-info>",
        templateUrl: "modules/rfx/templates/rfqcinfo.html",
        process: "RFQCInfo",
        controller: "RFQCInfoCtrl",
        controllerAs: "rfqcInfoCtrl",
        workspace: "shop",
    },
    "/rfxbuyerdecide/:rfqhId": {
        template: "<ixa-rfx-buyer-decide></ixa-rfx-buyer-decide>",
        templateUrl: "modules/rfx/templates/rfxbuyerdecide.html",
        process: "RFXEdit",
        controller: "RFXBuyerDecideCtrl",
        controllerAs: "rfxBuyerDecideCtrl",
        workspace: "shop",
    },
    "/rfx/offers/:rfqhId": {
        template: "<ixa-rfx-offers-list></ixa-rfx-offers-list>",
        templateUrl: "modules/rfx/templates/rfx-list-offers.html",
        process: "RFXView",
        controller: "RFXListOffersCtrl",
        controllerAs: "rfxListOffersCtrl",
        workspace: "shop",
    },
    "/rfx/offers/support/:rfqhId": {
        template: "<ixa-rfx-offers-support-list></ixa-rfx-offers-support-list>",
        templateUrl: "modules/rfx/templates/rfx-list-offers.html",
        process: "RFXRequestSupportView",
        controller: "RFXListOffersSupportCtrl",
        controllerAs: "rfxListOffersCtrl",
        workspace: "shop",
    },
    "/rfx/offer/support/:rfqsId": {
        template: "<ixa-rfx-offer-support></ixa-rfx-offer-support>",
        templateUrl: "modules/rfx/templates/rfx-offer.html",
        process: "RFXRequestSupportView",
        controller: "RFXOfferSupportCtrl",
        controllerAs: "rfxOfferCtrl",
        workspace: "shop",
    },
    "/rfx/offer/:rfqsId": {
        templateUrl: "modules/rfx/templates/rfx-offer.html",
        process: "RFXView",
        controller: "RFXOfferCtrl",
        controllerAs: "rfxOfferCtrl",
        workspace: "shop",
    },
    "/rfxitemcompare/:rfqiGroupId": {
        template: "<ixa-rfx-item-compare></ixa-rfx-item-compare>",
        templateUrl: "modules/rfx/templates/rfxitemcompare.html",
        process: "RFXEdit",
        controller: "RFXItemCompareCtrl",
        controllerAs: "rfxItemCompareCtrl",
        workspace: "shop",
    },
    "/rfx/comparisonoffers/:rfqhId": {
        template: "<ixa-rfx-list-comparison-offers></ixa-rfx-list-comparison-offers>",
        templateUrl: "modules/rfx/templates/rfx-list-comparison-offers.html",
        process: "RFXView",
        controller: "RFXListComparisonOffersCtrl",
        controllerAs: "rfxListComparisonOffersCtrl",
        workspace: "shop",
    },
    '/rfxrequestsupportlist': {
        templateUrl: 'modules/rfx/templates/rfxrequestsupportlist.html',
        process: "RFXRequestSupportView",
        controller: 'RFXRequestSupportListCtrl',
        controllerAs: 'rfxRequestSupportListCtrl',
        workspace: 'shop',
    },
    '/rfx/requestsupport/:rfqhId/:rfqcId?/:supplierId?/:tenderId?/:lotId?/:productIdToAdd?/:amountToAdd?': {
        templateUrl: 'modules/rfx/templates/rfxbuyer.html',
        process: "RFXRequestSupportView",
        controller: 'RFXRequestSupportCtrl',
        controllerAs: 'rfxBuyerCtrl',
        workspace: 'shop',
    },
});
